import React from 'react';
import CoinUsageView from './CoinUsageView';

const CoinUsagePage: React.FC = () => <CoinUsageView />;

export default CoinUsagePage;
